
    <b4a-product-simple-travel-list [travels]="travels" [clickedNew]="clickedNew.bind(this)"></b4a-product-simple-travel-list>
  


// WEBPACK FOOTER //
// ./src/app/product/simple-travel-list-page.container.ts.SimpleTravelListPageComponent.html